interface ErrorResponse {
	error: {
		userMessage: string;
		id: number;
		message: string;
		extraInfo: Record<string, unknown>;
	}
}

interface ApiError extends Error {
	response?: {
		data: ErrorResponse;
		status: number;
	};
}

export interface ErrorResult {
	shouldLogout: boolean;
	message: string;
}

export const handleApiError = (error: unknown): ErrorResult => {
	const apiError = error as ApiError;
	const errorData = apiError?.response?.data?.error;

	if (errorData) {
		switch (errorData.id) {
			case 624: // user disabled
				return {
					shouldLogout: true,
					message: errorData.userMessage || 'Your account has been suspended. Please reach out to the Language I/O support team for additional details.'
				};
			case 606: // consumer not found
				return {
					shouldLogout: true,
					message: errorData.userMessage || 'Unauthorized access.'
				};
			case 509: // consumer disabled
				return {
					shouldLogout: true,
					message: errorData.userMessage || 'Your account has been disabled. Please contact your Language I/O representative.'
				};
		}
		return {
			shouldLogout: false,
			message: errorData.userMessage || 'An unexpected error occurred'
		};
	}

	// Default error response if no error data is available
	return {
		shouldLogout: false,
		message: 'An unexpected error occurred'
	};

};